import React from "react";
import { observer } from "mobx-react";
import { Table, Tag, Skeleton, WidgetEmptyErrorPlaceholder, Scrollbar } from "@ann/web-components";
import { ContentContainer, NameWrapper, ErrorWrapper, EmptyWrapper, ScrollbarContainer } from "./Content.styled";
import AppointmentsItem from "../AppointmentsItemList/AppointmentsItemList.jsx";

const HEADERS = [
  { value: "vehicle", label: "Vehicle" },
  { value: "vin", label: "VIN" },
  { value: "timestamp", label: "Timestamp" },
  { value: "serviceMileage", label: "Service Mileage" },
  { value: "advisor", label: "Advisor" },
  { value: "createdVia", label: "Created Via" },
  { value: "status", label: "Status" },
];

const Content = observer(({ mode, loading, error, isEmpty, appointments, onRefresh }) => {
  if (loading) {
    return (
      <ContentContainer>
        <Skeleton height="420px" width="100%" />
      </ContentContainer>
    );
  }

  if (error) {
    return (
      <ContentContainer>
        <ErrorWrapper>
          <WidgetEmptyErrorPlaceholder
            icon="error"
            title="Something went wrong"
            message="We couldn't load your Appointments. Please try again."
            buttonText="Retry"
            showButton={true}
            onClick={onRefresh}
          />
        </ErrorWrapper>
      </ContentContainer>
    );
  }

  if (isEmpty || !appointments?.length) {
    return (
      <ContentContainer>
        <EmptyWrapper>
          <WidgetEmptyErrorPlaceholder
            icon="calendarToday"
            title="No appointments scheduled"
            message="We'll list confirmed appointments here."
            showButton={false}
          />
        </EmptyWrapper>
      </ContentContainer>
    );
  }

  const tableData =
    mode === "table"
      ? appointments.map((row) => ({
          ...row,
          vehicle: (
            <NameWrapper>
              <span>{row.vehicle}</span>
            </NameWrapper>
          ),
          status: (
            <Tag text={row.status} color={row.statusColor || "informative"} size="medium" />
          ),
        }))
      : appointments;

  return (
    <ContentContainer>
      <Scrollbar size="medium">
        <ScrollbarContainer>
          <Table
            showActions={false}
            headers={HEADERS}
            data={tableData}
            mode={mode}
            gridColumns={1}
            gridNode={(item) => <AppointmentsItem info={item} />}
          />
        </ScrollbarContainer>
      </Scrollbar>
    </ContentContainer>
  );
});

export default Content;
